import { Link } from "react-router-dom";

import { getPublicPage } from "../../seo/publicPages";
import { RELATED_GUIDES } from "./relatedGuideList";

type RelatedGuidesProps = {
  currentPath: string;
};

function guideTitle(path: string): string {
  return getPublicPage(path).headline;
}

export default function RelatedGuides({ currentPath }: RelatedGuidesProps) {
  const others = RELATED_GUIDES.filter((guide) => guide.path !== currentPath);

  return (
    <>
      <h2>Mai multe detalii</h2>
      <ul>
        {others.map((guide) => (
          <li key={guide.path}>
            <Link to={guide.path}>{guideTitle(guide.path)}</Link>
            {" — "}
            {guide.blurb}
          </li>
        ))}
      </ul>
    </>
  );
}
